import { BaseReq, PaginationReq, PaginationResp, UpdaterResp, FileRecord } from "@/core/interface";
import { getCurrentUserId } from "@/utils";
import moment from "moment";

export class QuantityRecord extends BaseReq {
  uuid: string = ""; // 唯一ID
  bizNo: string = ""; // 清单编号
  name: string = ""; // 清单名称
  feature: string = ""; // 项目特征
  unit: string = ""; // 结算单位
  projectWorkBudgetQuantitiesId: string | undefined = ""; // 施工预算工程量 ID
  budgetCount: number|undefined = undefined; // 施工预算 - 工程量
  budgetPrice: number|undefined = undefined; // 施工预算 - 综合单价
  price: number = 0; // 综合单价
  budgetTotalPrice: number = 0; // 施工预算 - 合价
  count: number = 0; // 本次上报-工程量
  totalPrice: number = 0; // 本次上报-合价
  remark: string = ""; // 备注
  isAdd: boolean = false; // 是否新增
}

export class ProgressReq extends BaseReq {
  contractId: string | undefined = undefined; // 合同 ID
  projectId: string = ""; // 项目 ID
  projectName: string = ""; // 项目名称
  projectAmount: number = 0; // 合同金额
  stageStartTime: string = ""; // 计划开始日期
  stageEndTime: string = ""; // 计划结束日期
  planStartDate: string = ""; // 计划开始日期
  planEndDate: string = ""; // 计划结束日期
  stageUseDay: number = 0; // 计划时长
  currentPrice: number = 0; // 本次上报完成产值
  projectTotalPrice: number = 0; // 项目累计上报完成产值
  operatorTenantUserId: string = getCurrentUserId(); // 经办人 ID
  remark: string = ""; // 备注
  writeQuantitiesReqs: QuantityRecord[] = []; // 工程量清单
  progressWritePlanDetailReqs:any=[];
  fileList: FileRecord[]; //附件
  projectWorkPlanId:string | undefined = undefined;//施工计划ID
  typeName:string='';//计划类型
  useDay:number=0;
  writeDate: string = moment().format("YYYY-MM-DD"); // 填报日期
  projectWorkLogIds:string | Array<string> = [];//施工日志ID
  
}
export class ProgressPageReq extends PaginationReq {
  projectName: string | undefined = undefined; // 项目名称
  startDate: string | undefined = undefined; // 签约开始日期
  endDate: string | undefined = undefined; // 签约结束日期
  progressWriteuserId: string | undefined = undefined; // 填报人
  flowStatus: string = "dtj"; //状态,
  progressStatus: string | undefined = undefined;
}

export class ProgressListRecord extends UpdaterResp {
  id: number = 0; // 进度填报ID
  bidNo: string = ""; // 进度填报编号
  projectId: string = ""; // 项目 ID
  projectName: string = ""; // 项目名称
  stageStartTime: string = ""; // 阶段开始日期
  stageEndTime: string = ""; // 阶段结束日期
  stageUseDay: number = 0; // 阶段时长
  currentPrice: number = 0; // 本次上报完成产值
  validStatus: string = ""; // 生效状态
  validStatusName: string = ""; // 生效状态
  flowStatus: string = ""; // 审批状态Code
  flowStatusName: string = ""; // 审批状态名称
}

export class ProgressPageResp extends PaginationResp<ProgressListRecord> {}

export class ProgressDetailResp extends UpdaterResp {
  id: string = ""; // 进度填报ID
  projectName: string = ""; //项目名称
  type:string='';//计划类型
  typeName:string='';//计划类型名称
}
